import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Node} from '../model/treeview/node';
import {TreeviewNodeEvent} from '../model/events/treeviewNodeEvent';
import {Leaf} from '../model/treeview/leaf';
@Component({
    selector:'node',
    template:`
        <li><input type="checkbox" id="item-0" /><label (dblclick)="triggerDbClick(node)" (contextmenu)="trigger($event)" (click)="triggerClick(node)" for="item-0">{{node.getName()}}</label>
            <ul *ngIf="node.getLeaves().length>0">
                <ng-container *ngFor="let leaf of node.getLeaves()">
                    <li class="leaf" *ngIf="setNodeType('leaf') && setNodePath(leaf.getPath())"><span (contextmenu)="trigger($event)" (click)="triggerClick(leaf)"><img alt="fileIcon" class="icon" src="../../assets/images/outlookEmail.png">{{leaf.getName()}}</span></li>
                </ng-container>
            </ul>
            <ul style="margin-left: 10px;" *ngIf="node.getNodeList().length>0">
                    <node  *ngFor="let node of node.getNodeList()"  (changeFileName)="triggerChangeFileName()" (nodeRightClick)="onRightClick($event)"  (nodeClick)="triggerNodeClick($event)" [node]="node"></node>
            </ul>
        </li>
    `,
    styles:[`
        @import url(https://fonts.googleapis.com/css?family=Lato:300,400,700);

        .icon{height:19px;margin-right:5px;}

        body {
            background: #245;
            font-family: 'Lato', Calibri, Arial, sans-serif;
            color: #333;
        }

        .container {
            margin: 50px auto 0;
            width: 300px;
            height: 1200px;
            background: #f5f5f5;
            padding: 30px;
            border-radius: 5px;
            border: solid 2px #777;
            box-shadow: 0 0 5px #333;
        }
        h1 {
            margin: 0 0 15px;
            color: #444;
        }

        ul
        {
            padding: 0;
            margin: 0;
            list-style: none;
        }
        .leaf{
            padding: 0;
            margin-left: 3px;
            list-style: none;
        }

        input
        {
            position: absolute;
            opacity: 0;
        }

        node
        {
            user-select: none;
        }

        p
        {
            color: #35d;
            text-decoration: none;
        }

        p:hover
        {
            text-decoration: underline;
        }

        input + label + ul
        {
            margin: 0 0 0 22px;
        }

        input ~ ul
        {
            display: none;
        }

        label,
        label::before
        {
            cursor: pointer;
        }

        input:disabled + label
        {
            cursor: default;
            opacity: .6;
        }

        input:checked:not(:disabled) ~ ul
        {
            display: block;
        }

        label,
        label::before
        {
            background: url("../../assets/images/icons.png") no-repeat;
        }

        label,
        a,
        label::before
        {
            display: inline-block;
            height: 16px;
            line-height: 16px;
            vertical-align: middle;
        }

        label
        {
            background-position: 18px 0;
        }

        label::before
        {
            content: "";
            width: 16px;
            margin: 0 22px 0 0;
            vertical-align: middle;
            background-position: 0 -32px;
        }

        input:checked + label::before
        {
            background-position: 0 -16px;
        }

        @media screen and (-webkit-min-device-pixel-ratio:0)
        {
            .css-treeview
            {
                -webkit-animation: webkit-adjacent-element-selector-bugfix infinite 1s;
            }

            @-webkit-keyframes webkit-adjacent-element-selector-bugfix
            {
                from
                {
                    padding: 0;
                }
                to
                {
                    padding: 0;
                }
            }
        }
    `]
})

export class NodeComponent {
    @Input() node:Node;

    private nodeType = 'node';
    private _nodePath = '';

    private x:number;
    private y:number;
    private showContext: boolean;

    @Output() nodeRightClick:EventEmitter<TreeviewNodeEvent> = new EventEmitter();
    @Output() nodeClick:EventEmitter<Leaf|Node> = new EventEmitter();
    @Output() nodeDbClick:EventEmitter<Node> = new EventEmitter();
    @Output() changeFileName:EventEmitter<Node> = new EventEmitter();

    // onRightClick(event: MouseEvent) {
    //
    //     if(this.showContext) {
    //         return false;
    //     }
    //     /*const origin = {
    //       left: e.pageX,
    //       top: e.pageY
    //     };*/
    //     console.log('clientX'+ event.clientX);
    //     console.log('clientY'+event.clientY);
    //     console.log('pageX'+event.pageX);
    //     console.log('pageY'+event.pageY);
    //     console.log('screenX'+event.screenX);
    //     console.log('screenY'+event.screenY);
    //     console.log('offsetX'+event.offsetX);
    //     console.log('offsetY'+event.offsetY);
    //     const elm = event.currentTarget as HTMLInputElement;
    //     /*if(this.viewMode !=='list') {
    //         this.x = (elm.offsetLeft+50);
    //         this.y = (elm.offsetTop+50);
    //     } else {*/
    //     this.x = (event.offsetX+elm.offsetWidth);
    //     this.y = (elm.offsetHeight+220);
    //     // }
    //     // - (event.srcElement.parentElement.parentElement.offsetLeft));
    //     // return false;
    //     // this.contextMenu.setCoordinates();
    //     // this.contextMenu.toggle();
    //     // @ts-ignore
    //     this.showContext = true;
    //     /* context.style.left=+'px';
    //      context.style.top=+'px';*/
    //     /*this.x = ((event.clientX+100<window.innerWidth-window.innerWidth*0.03)?(event.clientX+2):(event.clientX-100-2)); // event.pageX;
    //     this.y = ((event.clientY+100<window.innerHeight-window.innerWidth*0.03)?(event.clientY+2):(event.clientY-100-2));*/// event.pageY;
    // }
    //
    // onNewFolder() {
    //     this.showContext = false;
    // }
    updateNode(srcElement: any,node: Node) {
        alert(srcElement.innerText);
        node.setName(srcElement.innerText);
    }

    setNodeType(val: string) {
        this.nodeType = val;
        return true;
    }

    getNodeType() {
        return this.nodeType;
    }


    getNodePath(): string {
        return this._nodePath;
    }

    setNodePath(value: string) {
        this._nodePath = value;
        return true;
    }

    trigger(event: MouseEvent) {
        // alert(this.node.getName());
        const rightClickEvt = new TreeviewNodeEvent(event,this.node);

        this.nodeRightClick.emit(rightClickEvt);
    }

    triggerClick(val:(Node|Leaf)) {
        this.nodeClick.emit(val);
    }

    triggerDbClick(node:Node) {
        alert('hello double click');
        this.changeFileName.emit(node);
    }

    onRightClick(val: TreeviewNodeEvent) {
        this.nodeRightClick.emit(val);
    }

    triggerChangeFileName() {
        this.changeFileName.emit(this.node);
    }

    triggerNodeClick(val:(Node|Leaf)) {
        this.nodeClick.emit(val);
    }
}
